/* Gluca product page, IM8 inspired layer for the sections below the buy box.
   Adds small pill labels and serif headings with an italic accent, turns the "What is inside"
   tabs into accordions with contains / does not contain chips, rebuilds the comparison as a
   two column table, restyles the guarantee as a promise card and moves the FAQ below it.
   Content comes from what is already on the page, so theme editor copy stays the source. */
(function () {
  var buybox = document.getElementById('buybox');
  var root = buybox && buybox.parentElement;
  if (!root) return;

  var ICONS = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    cross: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="m7 7 10 10M17 7 7 17"/></svg>',
    eye: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z"/><circle cx="12" cy="12" r="3.2"/></svg>',
    sun: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 17.5h18M6.5 17.5a5.5 5.5 0 0 1 11 0"/><path d="M12 5v2.5M4.6 9.1l1.8 1.8M19.4 9.1l-1.8 1.8M8 21h8"/></svg>',
    drop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.2s6 6.6 6 11a6 6 0 0 1-12 0c0-4.4 6-11 6-11z"/><path d="M9.2 14.6a2.9 2.9 0 0 0 2.6 2.7"/></svg>',
    leaf: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 19c0-8 5.5-13 15-14-.6 9.5-6 15-14 15"/><path d="M5 19c3-4 6-6.5 10-8.5"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2.5 4.5 5.3v5.4c0 4.7 3.2 8.9 7.5 10.3 4.3-1.4 7.5-5.6 7.5-10.3V5.3z"/><path d="m8.8 11.8 2.2 2.2 4.3-4.4"/></svg>',
    others: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6" y="8" width="12" height="13" rx="2"/><path d="M9 8V5h6v3M9 13h6"/></svg>'
  };

  /* the page is ordered so each section answers the question the one above it raises */
  function sectionOf(sel) { var el = root.querySelector(sel); return el ? (el.closest('section') || el) : null; }
  function orderSections() {
    var order = [
      root.querySelector('.gl-team'),            /* 2. meet the team, straight under the buy box */
      sectionOf('.elare-card'),                  /* 3. what you get back */
      root.querySelector('#gluca-rev-clone') || sectionOf('.elare-review'),  /* 3. social proof, straight after it */
      sectionOf('.elare-split'),                 /* 4. mechanism: why drops wear off */
      sectionOf('.elare-stages'),                /* 5. how to use it, ten seconds */
      root.querySelector('#gluca-cmp-clone') || sectionOf('.elare-compare'), /* 7. why us, not the alternatives */
      root.querySelector('#faq'),                /* 9. FAQ */
      root.querySelector('section[data-slot="cta"]') || root.querySelector('.gim-promise') /* 10. guarantee + last add to cart */
    ];
    order.forEach(function (el) { if (el && el.parentNode === root) root.appendChild(el); });
  }
  /* dead weight for this buyer: the emoji icon grid and the second scrolling ticker */
  function cutDeadWeight() {
    var icons = sectionOf('.elare-icard');
    if (icons && icons.parentNode) icons.parentNode.removeChild(icons);
    var ticker = root.querySelector('[data-slot="ticker2"]');
    if (ticker && ticker.parentNode) ticker.parentNode.removeChild(ticker);
    var pills = root.querySelector('[data-slot="pills"]');
    if (pills && pills.parentNode) pills.parentNode.removeChild(pills);
    var stats = root.querySelector('[data-slot="stats"]');
    if (stats && stats.parentNode) stats.parentNode.removeChild(stats);
  }

  /* heading text (lower case) -> [pill label, heading with accent] */
  var HEADS = {
    'what you get back': ['Day to day', 'What you <em>get back</em>'],
    'what it costs to wait': ['Be honest with yourself', 'What it <em>costs to wait</em>'],
    'why this bottle and not the cheapest one': ['The formula', 'Why this bottle, <em>not the cheapest one</em>'],
    'where it fits in your morning': ['Nobody ever told you', 'Where it fits <em>in your morning</em>'],
    'ten seconds, before your drops': ['How to use it', 'Ten seconds, <em>before your drops</em>'],
    'frequently asked questions': ['Questions', 'What women ask <em>before they buy</em>']
  };

  function make(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function textOf(n) { return n ? (n.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function kicker(label, dark) {
    return make('p', 'gim-kicker' + (dark ? ' gim-kicker--inv' : ''), label);
  }

  function decorateHeading(h, dark) {
    if (!h || h.getAttribute('data-gim')) return;
    h.setAttribute('data-gim', '1');
    h.classList.add('gim-h');
    var map = HEADS[textOf(h).toLowerCase()];
    if (!map) return;
    h.innerHTML = map[1];
    h.parentNode.insertBefore(kicker(map[0], dark), h);
  }

  function sectionHeadings() {
    Array.prototype.forEach.call(root.querySelectorAll('.elare-h2'), function (h) {
      decorateHeading(h, !!h.closest('.elare-band--brand, .gim-faq'));
    });
  }

  /* ---------- What is inside: tabs -> accordions ---------- */
  /* the panels are filled by small scripts that can run after this one, so keep the copy here too */
  var DEFAULTS = {
    ingredients: ['Pure hypochlorous acid at 0.01%, the one active ingredient', 'The same compound your own immune cells make, which is why it is gentle enough for closed eyelids', 'Just three ingredients in total, so there is very little for a sensitive eye to react to'],
    expect: ['It feels cool and gentle the moment you spray, with nothing to rinse or wipe away.', 'The buildup along your lash line collects again every night, so this works best as a daily habit, like brushing your teeth.', 'Use it every morning and night, and give it a full thirty days before you decide.'],
    guarantee: ['Use it every morning and night for thirty days. If your eyes do not feel different, email us and we will refund your order in full.', 'No forms to fill in and nothing to send back.', 'A clean lid line takes consistent daily use, so a few days is not a fair test. Thirty days is.']
  };
  function real(items, fallback) {
    var kept = items.filter(function (t) { return t && !/^\s*add (your|exclusion)/i.test(t.replace(/<[^>]+>/g, '')); });
    return kept.length ? kept : fallback;
  }
  function listItems(panel) {
    return panel ? Array.prototype.map.call(panel.querySelectorAll('ul li'), function (li) { return li.innerHTML; }) : [];
  }
  function paragraphs(panel) {
    return panel ? Array.prototype.map.call(panel.querySelectorAll('.elare-pillpanel__txt > p'), function (p) { return p.innerHTML; }) : [];
  }
  function accItem(title, body, open) {
    var d = make('details', 'gim-acc__item');
    if (open) d.open = true;
    d.innerHTML = '<summary><span>' + title + '</span><i class="gim-acc__ic" aria-hidden="true"></i></summary><div class="gim-acc__body">' + body + '</div>';
    return d;
  }
  function checks(items) {
    return '<ul class="gim-checks">' + items.map(function (t) { return '<li>' + ICONS.check + '<span>' + t + '</span></li>'; }).join('') + '</ul>';
  }

  function buildInside() {
    var sec = root.querySelector('[data-slot="pills"]');
    if (!sec || sec.getAttribute('data-gim')) return;
    sec.setAttribute('data-gim', '1');
    sec.classList.add('gim-inside');
    var p1 = sec.querySelector('#gp1'), p4 = sec.querySelector('#gp4'), p5 = sec.querySelector('#gp5');
    var ingredients = real(listItems(p1), DEFAULTS.ingredients);
    var expect = real(paragraphs(p4), DEFAULTS.expect);
    var guarantee = real(paragraphs(p5), DEFAULTS.guarantee);

    var contains = ['Hypochlorous acid at 0.01%', 'Three ingredients in total', 'A fine mist made for closed eyelids'];
    var without = ['Preservatives', 'Soap', 'Detergents', 'Fragrance', 'Alcohol', 'Dyes'];
    var grid = '<p class="gim-inout__lead">Nothing to rinse off, and nothing left sitting on your lids.</p>' +
      '<div class="gim-inout">' +
        '<div class="gim-inout__col"><p class="gim-inout__head"><span class="gim-dot gim-dot--yes">' + ICONS.check + '</span>Contains</p>' +
          '<ul class="gim-inout__list">' + contains.map(function (t) { return '<li>' + ICONS.check + t + '</li>'; }).join('') + '</ul></div>' +
        '<div class="gim-inout__col"><p class="gim-inout__head"><span class="gim-dot gim-dot--no">' + ICONS.cross + '</span>Does not contain</p>' +
          '<ul class="gim-chips">' + without.map(function (t) { return '<li>' + ICONS.cross + t + '</li>'; }).join('') + '</ul></div>' +
      '</div>';

    var acc = make('div', 'gim-acc');
    if (ingredients.length) acc.appendChild(accItem('Key ingredients', checks(ingredients), true));
    acc.appendChild(accItem('What’s in it and what’s not', grid, true));
    acc.appendChild(accItem('How to use', '<p>Close your eyes and spray twice onto your eyelids, aiming for the lash line. Do it morning and night. Let it dry, then use your eye drops as usual.</p>', false));
    acc.appendChild(accItem('Why buy it here and not from a marketplace seller', '<p>You are buying from us, not from a seller you cannot name. Your order comes with our thirty day money-back guarantee, a subscription you can pause or cancel yourself, and an email address that reaches a person on our team.</p><p>On a marketplace you cannot see who stored the bottle, how long it sat there, or who to call when something is wrong, and a refund goes through that seller rather than through us. This goes on your eyelids twice a day. That is not the place to save three dollars.</p>', false));
    if (expect.length) acc.appendChild(accItem('What to expect', expect.map(function (t) { return '<p>' + t + '</p>'; }).join(''), false));
    if (guarantee.length) acc.appendChild(accItem('Money-back guarantee', guarantee.map(function (t) { return '<p>' + t + '</p>'; }).join(''), false));

    Array.prototype.forEach.call(sec.querySelectorAll('.elare-pillnav, .elare-pillpanel'), function (n) { n.parentNode.removeChild(n); });
    sec.appendChild(acc);
    return guarantee;
  }

  /* ---------- Formulated for you: emoji -> line icons ---------- */
  function buildIcons() {
    var pick = { '👓': 'eye', '🌅': 'sun', '💧': 'drop', '🌿': 'leaf' };
    var order = ['eye', 'sun', 'drop', 'leaf'];
    Array.prototype.forEach.call(root.querySelectorAll('.elare-icard__ic'), function (ic, i) {
      if (ic.getAttribute('data-gim')) return;
      ic.setAttribute('data-gim', '1');
      var key = pick[textOf(ic)] || order[i % order.length];
      ic.innerHTML = ICONS[key];
    });
    var band = root.querySelector('.elare-icard');
    if (band) band.closest('section').classList.add('gim-for');
  }

  /* ---------- Guarantee promise ---------- */
  function buildPromise(guarantee) {
    /* the promise is the last thing she reads before the final button */
    var sec = root.querySelector('section[data-slot="cta"]');
    if (!sec || sec.getAttribute('data-gim')) return;
    sec.setAttribute('data-gim', '1');
    var btn = sec.querySelector('a.elare-cta');
    var detail = (guarantee && guarantee[0]) || 'Use it every morning and night for thirty days. If your eyes do not feel different, email us and we will refund your order in full.';
    var chips = ['30-day guarantee', 'Free shipping, always', 'Cancel anytime', 'No preservatives'];
    sec.className = 'gim-promise';
    sec.innerHTML =
      '<p class="gim-kicker">Our promise</p>' +
      '<h2 class="gim-h gim-promise__h">Thirty days, <em>on us</em></h2>' +
      '<p class="gim-promise__sub">Use it every morning and night. If nothing changes, or your eye doctor says no, we refund you.</p>' +
      '<div class="gim-promise__card">' +
        '<p class="gim-promise__big">30<span>Day</span></p>' +
        '<p class="gim-promise__lab">Money-back guarantee</p>' +
        '<p class="gim-promise__txt">' + detail + '</p>' +
        '<p class="gim-promise__doc">Take the bottle to your next eye appointment. Daily lid hygiene is step one in international dry eye guidelines, so your doctor will know exactly what it\u2019s for. If they say it\u2019s not right for you, we refund you.</p>' +
      '</div>' +
      '<ul class="gim-promise__chips">' + chips.map(function (c) { return '<li>' + c + '</li>'; }).join('') + '</ul>' +
      '<p class="elare-guarantee gim-promise__foot">No forms to fill in and nothing to send back.</p>';
    if (btn) {
      btn.className = 'elare-cta gim-btn';
      btn.textContent = 'Add to cart';
      sec.insertBefore(btn, sec.querySelector('.gim-promise__foot'));
    }
    var faq = root.querySelector('#faq');
    if (faq) {
      faq.classList.add('gim-faq');
      root.insertBefore(sec, faq);
    }
  }

  /* ---------- Reviews and comparison (loaded from the home page after a fetch) ---------- */
  function buildReviews() {
    var top = root.querySelector('#gluca-rev-clone .ev2-rev .top');
    if (!top || top.getAttribute('data-gim')) return;
    top.setAttribute('data-gim', '1');
    var h = top.querySelector('h2');
    if (h) {
      h.classList.add('gim-h');
      h.parentNode.insertBefore(kicker('Customer reviews', false), h);
    }
    root.querySelector('#gluca-rev-clone').classList.add('gim-rev');
  }

  /* Comparison, rebuilt for a phone: three stacked cards, one per alternative she is
     weighing, with only claims we can defend. */
  var COMPARE = [
    { name: 'Eye drops on their own', lines: [
      ['no', 'Land on the surface of your eye, not on the edge of your eyelid'],
      ['no', 'Do not clear what is blocking the oil glands'],
      ['no', 'Plain drops last a few hours, so you top up again']
    ] },
    { name: 'Drugstore lid wipes and scrubs', lines: [
      ['no', 'Many are soap or detergent based, and you rub a pad along a thin lid'],
      ['no', 'Usually need rinsing or wiping off afterwards'],
      ['no', 'One pad per eye, so it turns into a chore you skip']
    ] },
    { name: 'Unbranded marketplace sprays', lines: [
      ['no', 'Concentration and pH are not always stated on the listing'],
      ['no', 'You cannot see who handled the bottle before it reached you'],
      ['no', 'A return goes through that seller, not through us']
    ] }
  ];
  var COMPARE_US = [
    ['yes', 'Cleans the one place your drops never reach, in ten seconds'],
    ['yes', 'Made for thin, sensitive lids: three ingredients, no soap, no preservatives'],
    ['yes', 'Goes on closed eyes. Nothing to rinse, nothing to rub'],
    ['yes', 'Bought straight from us, with thirty days to change your mind']
  ];
  function compareList(rows) {
    return '<ul class="gim-cmp__list">' + rows.map(function (r) {
      return '<li class="is-' + r[0] + '"><span class="gim-dot gim-dot--' + r[0] + '">' + (r[0] === 'yes' ? ICONS.check : ICONS.cross) + '</span><span>' + r[1] + '</span></li>';
    }).join('') + '</ul>';
  }
  /* tight packshot, so the bottle fills the tile instead of floating in white space */
  var BOTTLE_IMG = 'https://cdn.shopify.com/s/files/1/1020/9610/9937/files/gluca-cleansing-spray-thumb.jpg?width=320';
  /* Side by side: our bottle against a plain unbranded one. Six short rows, scannable in seconds. */
  var VS_ROWS = [
    { label: 'The active ingredient', us: 'Hypochlorous acid, made by your own body', them: 'Often not named' },
    { label: 'How strong it is', us: '0.01%, stated up front', them: 'Rarely stated' },
    { label: 'What else is in the bottle', us: 'Purified water and salt. That is all', them: 'Often detergents and fragrance' },
    { label: 'Your natural eyelid oils', us: 'Left where they belong', them: 'Detergents can strip them' },
    { label: 'Who stands behind it', us: 'Gluca, direct', them: 'A marketplace seller' },
    { label: 'If your eye doctor says no', us: 'We refund you', them: 'No promise' }
  ];
  var PLAIN_BOTTLE =
    '<svg class="gvs__blank" viewBox="0 0 80 108" aria-hidden="true" focusable="false">' +
    '<rect x="30" y="4" width="20" height="13" rx="3"/>' +
    '<rect x="26" y="17" width="28" height="10" rx="3"/>' +
    '<rect x="16" y="27" width="48" height="77" rx="10"/>' +
    '<rect x="24" y="46" width="32" height="26" rx="3" class="gvs__blanklabel"/></svg>';

  function buildCompare() {
    var clone = root.querySelector('#gluca-cmp-clone');
    var cmp = clone && clone.querySelector('.ev2-cmp');
    if (!cmp || clone.getAttribute('data-gim')) return;
    clone.setAttribute('data-gim', '1');
    var sec = make('section', 'gim-cmp gim-cmp--vs');
    sec.appendChild(kicker('How we compare', false));
    sec.appendChild(make('h2', 'gim-h', 'Why this, <em>and not the rest</em>'));
    sec.appendChild(make('p', 'gim-sub', 'What is actually in the bottle, next to an ordinary unbranded lid spray.'));

    var rows = VS_ROWS.map(function (r) {
      return '<div class="gvs__row">' +
        '<span class="gvs__lbl">' + r.label + '</span>' +
        '<span class="gvs__c gvs__c--us"><span class="gvs__tick" aria-hidden="true">' + ICONS.check + '</span>' + r.us + '</span>' +
        '<span class="gvs__c gvs__c--them">' + r.them + '</span>' +
      '</div>';
    }).join('');

    var table = make('div', 'gvs');
    table.innerHTML =
      '<div class="gvs__head">' +
        '<span class="gvs__lbl"></span>' +
        '<span class="gvs__c gvs__c--us"><span class="gvs__tag">Made for 55+</span><img src="' + BOTTLE_IMG + '" alt="Gluca Daily Eyelid Cleansing Spray" width="260" height="260" loading="lazy"><b>Gluca</b></span>' +
        '<span class="gvs__c gvs__c--them">' + PLAIN_BOTTLE + '<b>Unbranded spray</b></span>' +
      '</div>' + rows;
    sec.appendChild(table);

    var a = make('a', 'elare-cta gim-btn', 'Start today');
    a.href = '#buybox';
    a.setAttribute('data-elare-scroll', 'buybox');
    sec.appendChild(a);
    sec.appendChild(make('p', 'gvs__note', 'Why it matters: soaps and detergents lift away the thin layer of oil your tears need to stop them evaporating. Hypochlorous acid cleans the lash line without touching it.'));
    sec.appendChild(make('p', 'gim-foot', ICONS.shield + '30-day money-back guarantee'));
    clone.innerHTML = '';
    clone.classList.add('gim-cmpwrap');
    clone.appendChild(sec);
  }

  var clonesPlaced = false;
  function safeOrder() { orderSections(); }
  function lower() {
    buildReviews();
    buildCompare();
    sectionHeadings();
    if (!clonesPlaced && root.querySelector('#gluca-cmp-clone') && root.querySelector('#gluca-rev-clone')) {
      clonesPlaced = true;
      safeOrder();
    }
  }

  function init() {
    root.classList.add('gim');
    var stats = root.querySelector('[data-slot="stats"]');
    if (stats) stats.classList.add('gim-stats');
    var stages = root.querySelector('.elare-stages');
    if (stages) stages.closest('section').classList.add('gim-steps');
    var benefits = root.querySelector('.elare-card');
    if (benefits) benefits.closest('section').classList.add('gim-benefits');
    var split = root.querySelector('.elare-split');
    if (split) split.classList.add('gim-split');
    var guarantee = buildInside();
    buildIcons();
    buildPromise(guarantee);
    cutDeadWeight();
    orderSections();
    initVideo();
    lower();
    /* the reviews and comparison are fetched from the home page section after this script
       runs, so poll briefly until they land instead of relying on observer timing */
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      lower();
      var done = root.querySelector('#gluca-cmp-clone[data-gim]') && root.querySelector('.gim-rev');
      if (done || tries > 75) clearInterval(timer);
    }, 400);
  }

  /* claymation explainer: loads only when near the viewport, plays muted while on screen,
     pauses off screen, and waits for a tap when the visitor prefers reduced motion */
  var VID_LOAD_MARGIN = '300px 0px';
  var VID_PLAY_RATIO = 0.5;
  function initVideo() {
    var wrap = root.querySelector('.gl-vid');
    var video = wrap && wrap.querySelector('.gl-vid__v');
    if (!video) return;
    var snd = wrap.querySelector('.gl-vid__snd');
    var sndText = wrap.querySelector('.gl-vid__snd-t');
    var cta = wrap.querySelector('[data-gl-vid-cta]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var visible = false;

    function load() {
      if (video.getAttribute('src')) return;
      video.setAttribute('src', video.getAttribute('data-src'));
      video.preload = 'auto';
    }
    function play() {
      load();
      var p = video.play();
      if (p && p.catch) p.catch(function () { wrap.classList.add('is-paused'); });
    }
    function sync() {
      if (visible && !reduceMotion) play();
      else if (!video.paused) video.pause();
    }
    video.addEventListener('play', function () { wrap.classList.remove('is-paused'); });
    video.addEventListener('pause', function () { wrap.classList.add('is-paused'); });
    if (reduceMotion) wrap.classList.add('is-paused');

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) load();
      }, { rootMargin: VID_LOAD_MARGIN }).observe(video);
      new IntersectionObserver(function (entries) {
        visible = entries[0].intersectionRatio >= VID_PLAY_RATIO;
        sync();
      }, { threshold: [0, VID_PLAY_RATIO] }).observe(video);
    } else {
      load();
    }

    video.addEventListener('click', function () {
      if (video.paused) play(); else video.pause();
    });
    if (snd) snd.addEventListener('click', function () {
      var turnOn = video.muted;
      video.muted = !turnOn;
      if (turnOn) { video.currentTime = 0; play(); }
      snd.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
      if (sndText) sndText.textContent = turnOn ? 'Sound on' : 'Tap for sound';
    });
    /* the video sits above the buy box, so the button takes her down to the options */
    if (cta) cta.addEventListener('click', function (e) {
      var target = buybox.querySelector('.elare-info') || buybox;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
